/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Fragment, useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import "./manageContent.scss";
import AddModal from "./Manage-Add-Content/addModal";
import AddSubjectModal from "./Manage-Add-Content/addSubjectModal";
import Switch from "react-switch";
import { clearErrors } from '../../Redux/ActionCreators/errorAction';
import {
    resetTabs, getActiveBtn, openAddProgram, backToProgram,
    getCourseList, savedClassroom, updateClassroom, updateStatusClassroom, confirmDeleteClassroom,
    getSubjectList, getNextSubjectList, savedSubject, updateSubject, updateStatusSubject, confirmDelete, getAllSubjects,
    getPracticeTestList, getFilterTest,
    deleteQuizQuestions, savedQuestions, openAddSubject, handleModalClose, changeQuestionStatus, changeTestStatus,
    showSideBar, savedNewQuiz, resetLoader, getQuizQuestion, editedQuiz, getQuestionForEdit, editedQuestion, resetPercentage,
    getClubbedQuestionList, getQuestionFromSubject, getFilterSubject, getSearchQuestion, getChapterOfSub, getSubjectFromClassroom,
    getWhiteboardList,
    getWhiteboardDetails,
    updateStatusWhiteboard,
    updateEnableWhiteBoard,
    getChapters,
    getTopics,
    getSections,
    assignSections,
} from '../../Redux/ActionCreators/manageContentAction';
import { TopicLoader } from "../../Loader/loader";
import Select, { components } from 'react-select';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ConfirmModal from "../../utils/confirmModal";
import InfiniteScroll from 'react-infinite-scroll-component';
import ViewResource from "../../utils/viewResource";


const DropdownIndicator = props => {
    return (
        <components.DropdownIndicator {...props}>
            <img src='/images/select-indicator.svg' alt='' />
        </components.DropdownIndicator>
    );
};

function ManageContent(props) {
    const [activeBtn, setActiveBtn] = useState("course");
    const [page, setPage] = useState(1);
    const [isFocused, setIsFocused] = useState(false);
    const [questionQuery, setQuestionQuery] = useState('');
    const [subject, setSubject] = useState('');
    const [edit, setEdit] = useState(false);
    const [details, setDetails] = useState('')
    const [search, setSearch] = useState('');
    const [query, setQuery] = useState('');
    const [isOpenFilter, setIsOpenFilter] = useState(false);
    const [isOpenQuestionFilter, setIsOpenQuestionFilter] = useState(false);
    const [chapter, setChapter] = useState(null);
    const [topic, setTopic] = useState(null);
    const [selectedSections, setSelectedSections] = useState(null);
    const [loading, setloading] = useState(false);
    const [isConfirm, setIsConfirm] = useState(false);
    const [deleteId, setDeleteId] = useState('');
    const [testQuery, setTestQuery] = useState('');
    const [isView, setIsView] = useState(false);
    const [addSections, setAddSections] = useState(false);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const {
        activeButton, isClassLoading, courseList, subjectList, selectFromSubject, chapterList, topicsList, isAddSubject, editSubject, editObj, isShow, questionList, questionListForQuiz, practiceList, clubQuestionList, isViewed, isQuestionLoading, subjectChapters, editQuestionData, whiteboardList, isWhiteboardLoading, whiteboardDetails, sectionsFromSubject
    } = useSelector(state => state.manageContent);

    useEffect(() => {
        window.scrollTo(0, 0);
        window.onbeforeunload = function () {
            window.scrollTo(0, 0);
        };
        const firstRender = async () => {
            dispatch(resetTabs());
            dispatch(clearErrors());
            dispatch(showSideBar());
            localStorage.getItem('role') === 'state-admin' && setActiveBtn('course')
            if (activeButton === "subject") {
                setActiveBtn('subject');
                await dispatch(getSubjectList(1, search));
            }
            else {
                dispatch(getCourseList());
            }
        }

        firstRender();

        return (() => {
            // deleteQuizQuestions();
        })
    }, [])

    const onBtnChange = async (e) => {
        await dispatch(getActiveBtn(e));
        await dispatch(resetLoader());
        setActiveBtn(e);
        setSubject('');
        setQuestionQuery('');
        setPage(1);
        if (e === "course") {
            dispatch(getCourseList());
        } else if (e === "subject") {
            await dispatch(getSubjectList(1, search));
        } else if (e === "question-bank") {
            await dispatch(getClubbedQuestionList());
            await dispatch(getAllSubjects());
        } else if (e === "practice-test") {
            await dispatch(getPracticeTestList('practice', '', ''));
            await dispatch(getAllSubjects());
        } else if (e === "recorded-classes") {
            await dispatch(getWhiteboardList());
        }
    };

    const fetchData = () => {
        setPage(page + 1);
        dispatch(getNextSubjectList(page + 1, search))
    }


    const timerRef1 = React.useRef(null);


    const searchQuery = (val) => {
        clearTimeout(timerRef1.current);
        setSearch(val);
        setPage(1);
        timerRef1.current = setTimeout(() => delaySearch(val), 800);
    };

    const delaySearch = async (val) => {
        await dispatch(getSubjectList(page, val));
    }

    useEffect(() => {
        if (activeBtn === 'question-bank') {
            setDetails(editQuestionData);
        }
    }, [editQuestionData])


    const addPrograms = async (el) => {
        if (el) {
            setEdit(true);
            if (activeBtn === 'practice-test') {
                dispatch(getQuizQuestion(el._id));
                setDetails(el);
                setEdit(true);
            }
            else if (activeBtn === 'question-bank') {
                await dispatch(getQuestionForEdit('Question', el));
                dispatch(getAllSubjects());
                setEdit(true);
            }
            else {
                setDetails(el);
                setEdit(true);
            }
        } else {
            if (activeBtn === 'question-bank' || activeBtn === 'practice-test') {
                dispatch(getAllSubjects());
            }
            setEdit(false);
            setDetails(null);
        }
        dispatch(openAddProgram());
    };

    const handleAddSections = async () => {
        setAddSections(false);
        const obj = {
            whiteboard_id: details?._id,
            section_ids: selectedSections?.map(section => section.value) || []
        };
        await dispatch(assignSections(details?.subject_id?._id, obj));
        await dispatch(updateEnableWhiteBoard({
            whiteboard_id: details?._id,
            enable: !details.enable
        }))
        await dispatch(getWhiteboardList());
        setSelectedSections([]);
    };

    const backToMain = async () => {
        dispatch(backToProgram());
        if (activeBtn === 'question-bank') {
            await dispatch(getQuestionFromSubject(subject?.value, 'mcq', '', ''));
        }
        setDetails('');
        setChapter(null);
        setTopic(null);
    };

    const openView = async (el) => {
        await dispatch(getWhiteboardDetails(el._id));
        setIsView(true);
    }

    const closeDetails = () => {
        setIsView(false);
    }

    const handleModal = async () => {
        await dispatch(handleModalClose());
    };

    const goToSubject = (id, classroom) => {
        navigate("/manage-content/subject", {
            state: { id, classroom },
        });
    };


    const handleClassroomStatus = (detail) => {
        let obj = {
            course_id: detail?._id,
            active: !detail.active
        }
        dispatch(updateStatusClassroom(obj));
    }

    const handleSubjectStatus = (detail) => {
        let obj = {
            subject_id: detail?._id,
            active: !detail.active
        }
        dispatch(updateStatusSubject(obj));
    }

    const handleWhiteboardStatus = (detail) => {
        let obj = {
            whiteboard_id: detail?._id,
            active: !detail.active
        }
        dispatch(updateStatusWhiteboard(obj));
    }

    const EnableWhiteBoardToStudents = async (detail) => {
        console.log(detail)
        setDetails(detail);
        setSelectedSections(detail?.section_ids?.map(section => ({ value: section._id, label: section.name })) || []);
        let obj = {
            whiteboard_id: detail?._id,
            enable: !detail.enable
        }
        if (!detail.enable) {
            setAddSections(true);
            await dispatch(getSections(detail?.subject_id?._id, detail?._id));
        } else {
            await dispatch(updateEnableWhiteBoard(obj));
        }
    }

    const editWhiteboard = (detail) => {
        dispatch(editWhiteboard(detail));
    }

    const goToChapter = (id, title, details) => {
        navigate("/manage-content/chapter", {
            state: { id: id, title: title, details: details, subject: true },
        });
    };

    const openDelete = (detail) => {
        setIsConfirm(true);
        setDeleteId(detail._id);
    }


    const handleTestStatus = (id, checked) => {
        let obj = {
            quiz_id: id,
            active: !checked
        }
        dispatch(changeTestStatus(obj));
    }

    const handleQuestionStatus = (id, checked) => {
        let obj = {
            question_id: id,
            active: !checked
        }
        dispatch(changeQuestionStatus(obj));
    }



    const checkFocus = () => {
        // dummy element
        let dummyEl = document.getElementById("express-form-typeahead");
        // check for focus
        let isFocused = document.activeElement === dummyEl;

        if (isFocused) {
            setIsFocused(isFocused);
        } else {
            setIsFocused(false);
        }
    };


    const selectSubject = (e) => {
        setSubject(e);
    }

   const handleSelectSections = (selected) => {
    if (selected.some(option => option.value === 'all')) {
        // If "All Sections" was just clicked, select all sections
        if (!selectedSections.some(opt => opt.value === 'all')) {
            setSelectedSections([
                ...sectionsFromSubject.sections.map(section => ({
                    value: section._id,
                    label: section.name
                }))
            ]);
        }
    } 
    // If "All Sections" is being deselected
    else if (selectedSections.some(opt => opt.value === 'all')) {
        setSelectedSections([]);
    }
    // If all sections are manually selected
    else if (selected.length === sectionsFromSubject.sections.length) {
        setSelectedSections([
            ...selected
        ]);
    }
    // Normal selection/deselection
    else {
        setSelectedSections(selected);
    }
};

    const handleChapterChange = (selected) => {
        setChapter(selected);
        dispatch(getTopics(selected?._id));
        setTopic(null); // Reset topic when chapter changes
    };

    const handleTopicChange = (selected) => {
        setTopic(selected);
    };

    const searchQuestions = (e) => {
        setQuery(e.target.value);
        dispatch(getSearchQuestion(e.target.value));
    };

    const searchQuestionSubject = (val) => {
        setQuestionQuery(val);
        dispatch(getFilterSubject(val));
    }

    const searchPracticeTest = (val) => {
        setTestQuery(val);
        dispatch(getFilterTest(val));
    }


    const openFilter = () => {
        setIsOpenFilter(true);
    }

    const openQuestionFilter = () => {
        setIsOpenQuestionFilter(true);
    }

    const applyQuestionFilter = async () => {
        await dispatch(getPracticeTestList('practice', subject?.value, chapter?._id));
        setIsOpenQuestionFilter(false);
    }

    const applyFilter = async () => {
        await dispatch(getQuestionFromSubject(subject?.value, 'mcq', chapter?.value || '', topic?.value || ''));
        setIsOpenFilter(false);
    }



    const viewQuestions = async (el) => {
        setloading(true);
        await dispatch(getQuestionFromSubject(el._id, 'mcq', '', ''));
        await dispatch(getChapters(el._id));
        window.scrollTo(0, 0);
        setloading(false);
        setSubject({ label: el.title, value: el._id });
        setChapter(null);
        setTopic(null);
    }


    return (
        <Fragment>

            {<div className="mobile-coming">
                <div className="mobile-inner-hide">
                    <img src="/images/mobile-error.svg" alt='' />
                    <h4>Please visit the website on your Desktop/Laptop</h4>
                    <p>Mobile view coming soon</p>
                </div>

            </div>}
            {!isShow ? (
                <div className="manage-content-holder">
                    <h1>Manage Content</h1>
                    {
                        <div className="content-tabs">
                            <button
                                className={
                                    activeBtn === "course" ? "active-btn" : null
                                }
                                onClick={() => onBtnChange("course")}
                            >
                                Courses
                            </button>
                            &nbsp;
                            <button
                                className={
                                    activeBtn === "subject" ? "active-btn" : null
                                }
                                onClick={() => onBtnChange("subject")}
                            >
                                Subjects
                            </button>
                            &nbsp;
                            <button
                                className={
                                    activeBtn === "practice-test" ? "active-btn" : null
                                }
                                onClick={() => onBtnChange("practice-test")}
                            >
                                Practice Tests
                            </button>
                            &nbsp;
                            <button
                                className={
                                    activeBtn === "question-bank" ? "active-btn" : null
                                }
                                onClick={() => onBtnChange("question-bank")}
                            >
                                Question Bank
                            </button>
                            &nbsp;
                            <button
                                className={
                                    activeBtn === "recorded-classes" ? "active-btn" : null
                                }
                                onClick={() => onBtnChange("recorded-classes")}
                            >
                                Recordings
                            </button>

                        </div>
                    }
                    {
                        activeBtn === "course" ? (
                            <Fragment>

                                <div className="content-header">
                                    {

                                        <Fragment>
                                            {localStorage.getItem('role')?.includes('state-admin') ? null :
                                                <button onClick={() => addPrograms(null)}>
                                                    <img src="/images/plus-white.svg" alt="" /> &nbsp; Add
                                                    Course
                                                </button>}
                                            <div class="animated-search d-none">
                                                <input
                                                    id="express-form-typeahead"
                                                    autoComplete="off"
                                                    onBlur={checkFocus}
                                                    onFocus={checkFocus}
                                                    spellCheck="false"
                                                    type="text"
                                                />
                                                <div class="symbol">
                                                    <img src="/images/search1.svg" alt="" />
                                                </div>
                                                {isFocused ? (
                                                    <img
                                                        src="/images/close2.png"
                                                        alt=""
                                                        className="close-input"
                                                        onClick={() => setIsFocused(false)}
                                                    />
                                                ) : (
                                                    ""
                                                )}
                                            </div>
                                        </Fragment>
                                    }

                                    <div className="content-heading">
                                        <ul>
                                            <li>
                                                <div>Course</div>
                                                <div>Affliation</div>
                                                <div>Class</div>
                                                <div>Subjects</div>
                                                <div>Status</div>
                                                {localStorage.getItem('role')?.includes('state-admin') ? null : <div>Actions</div>}
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                {isClassLoading ? (
                                    <div>
                                        <TopicLoader />
                                    </div>
                                ) : courseList !== undefined && courseList.length > 0 ? (
                                    <ul className='program-list'>
                                        {
                                            courseList !== undefined && courseList.map((el, index) => {
                                                return (
                                                    <li key={index}
                                                        onClick={(e) => {
                                                            e.preventDefault()
                                                            goToSubject(el._id, el.name)
                                                        }}>

                                                        <div className='program-name text-capitalize d-flex align-items-center' >
                                                            <div style={{ width: '56px' }}>
                                                                <img src={el.image} className='rounded' alt='' width='56px' height='32px' />
                                                            </div> &nbsp;&nbsp;
                                                            <p>{el.name}</p>
                                                        </div>

                                                        <div className="text-center">
                                                            <p style={{ color: '#696873' }}>{el.affiliation?.name}</p>
                                                        </div>

                                                        <div className="text-center">
                                                            <h3>{el.class}</h3>
                                                        </div>
                                                        <div className="text-center">
                                                            <h3>{el.subjects}</h3>
                                                        </div>
                                                        <div className="text-center">
                                                            {localStorage.getItem('role')?.includes('state-admin') ? (el.active ? "Active" : "Inactive") :
                                                                <p
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        e.stopPropagation();
                                                                        handleClassroomStatus(el);
                                                                    }}
                                                                >
                                                                    <Switch
                                                                        width={30}
                                                                        height={16}
                                                                        uncheckedIcon={false}
                                                                        checkedIcon={false}
                                                                        onColor="#00B24B"
                                                                        checked={el.active}
                                                                        onChange={(e) => { console.log(e) }}
                                                                    />
                                                                    <br />
                                                                    {el.active ? "Active" : "Inactive"}
                                                                </p>}
                                                        </div>
                                                        {localStorage.getItem('role')?.includes('state-admin') ? null :
                                                            <div className='text-center'>
                                                                <img src='/images/edit.svg' alt='' onClick={(e) => {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    addPrograms(el)
                                                                }} /> &nbsp;&nbsp;
                                                                {el.active ? null : <img
                                                                    src="/images/delete.svg"
                                                                    alt=""
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        e.stopPropagation();
                                                                        openDelete(el)
                                                                    }}
                                                                />}
                                                                {/* <img src='/images/menu.svg' alt='' /> */}
                                                            </div>}
                                                    </li >
                                                )
                                            })
                                        }

                                    </ul >) : (
                                    <div className="empty-list">
                                        <img src="/images/empty.png" alt="" />
                                        <p>You have not added any courses yet.</p>
                                    </div>
                                )}
                            </Fragment>
                        ) :
                            activeBtn === "subject" ? (
                                <Fragment>
                                    <div className="content-header">
                                        <Fragment>
                                            <button
                                                onClick={() => dispatch(openAddSubject(null, false))}
                                            >
                                                <img src="/images/plus-white.svg" alt="" /> &nbsp; Add
                                                Subject
                                            </button>
                                            <div class="animated-search">
                                                <input
                                                    id="express-form-typeahead"
                                                    autoComplete="off"
                                                    onBlur={checkFocus}
                                                    onFocus={checkFocus}
                                                    spellCheck="false"
                                                    type="text"
                                                    value={search}
                                                    onChange={(e) => searchQuery(e.target.value)}
                                                />
                                                <div class="symbol">
                                                    <img src="/images/search1.svg" alt="" />
                                                </div>
                                                {isFocused ? (
                                                    <img
                                                        src="/images/close2.png"
                                                        alt=""
                                                        className="close-input"
                                                        onClick={() => setIsFocused(false)}
                                                    />
                                                ) : (
                                                    ""
                                                )}
                                            </div>
                                        </Fragment>
                                        <div className="content-heading">
                                            <ul>
                                                <li>
                                                    <div>Subjects</div>
                                                    <div>Affiliation</div>
                                                    <div>Chapters</div>
                                                    <div>Items</div>
                                                    <div>Status</div>
                                                    <div>Actions</div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    {isClassLoading ? (
                                        <div>
                                            <TopicLoader />
                                        </div>
                                    ) : subjectList !== undefined && subjectList?.length > 0 ? (
                                        <InfiniteScroll
                                            dataLength={subjectList && subjectList?.length} //This is important field to render the next data
                                            next={fetchData}
                                            hasMore={true}
                                        >
                                            <ul className="program-list">
                                                {
                                                    subjectList?.map((el, index) => {
                                                        return (
                                                            <li
                                                                key={el._id}
                                                                onClick={() =>
                                                                    goToChapter(el._id, el.name, el)
                                                                }
                                                            >
                                                                <div className='program-name text-capitalize d-flex align-items-center'>
                                                                    <div style={{ width: '56px' }}>
                                                                        <img src={el.image} className='rounded' alt='' width='56px' height='32px' />
                                                                    </div> &nbsp;&nbsp;
                                                                    <p>{el.name}</p>
                                                                </div>
                                                                <div className="text-center" style={{ fontFamily: 'Roboto' }}>
                                                                    <p style={{ color: '#696873' }}>{el.affiliation?.name}</p>
                                                                </div>
                                                                <div className="text-center">
                                                                    <h3>{el?.chapters}</h3>
                                                                </div>


                                                                <div className="text-center">
                                                                    <h3>{el.articles + el.videos + el.quizzes + el.documents}</h3>
                                                                </div>
                                                                {localStorage.getItem('role') === 'sme' ?
                                                                    <div className="text-center">
                                                                        <p> {el.active ? "Active" : "Inactive"}</p>
                                                                    </div>
                                                                    :
                                                                    <div className="text-center">
                                                                        <p
                                                                            onClick={(e) => {
                                                                                e.preventDefault();
                                                                                e.stopPropagation();
                                                                                handleSubjectStatus(el);
                                                                            }}
                                                                        >
                                                                            <Switch
                                                                                width={30}
                                                                                height={16}
                                                                                uncheckedIcon={false}
                                                                                checkedIcon={false}
                                                                                onColor="#00B24B"
                                                                                checked={el.active}
                                                                                onChange={(e) => { console.log(e) }}
                                                                            />
                                                                            <br />
                                                                            {el.active ? "Active" : "Inactive"}
                                                                        </p>
                                                                    </div>
                                                                }
                                                                <div className="text-center">
                                                                    <img
                                                                        src="/images/edit.svg"
                                                                        alt=""
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            e.stopPropagation();
                                                                            dispatch(openAddSubject(el, true));
                                                                        }}
                                                                    />{" "}
                                                                    &nbsp;&nbsp;
                                                                    {el.active ? null : <img
                                                                        src="/images/delete.svg"
                                                                        alt=""
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            e.stopPropagation();
                                                                            openDelete(el)
                                                                        }}
                                                                    />}
                                                                    {/* &nbsp;&nbsp;
                                                                <img
                                                                    src="/images/menu.svg"
                                                                    alt=""
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        e.stopPropagation();
                                                                    }}
                                                                /> */}
                                                                </div>
                                                            </li>
                                                        );
                                                    })}
                                            </ul>
                                        </InfiniteScroll>
                                    ) : (
                                        <div className="empty-list">
                                            <img src="/images/empty.png" alt="" />
                                            <p>You have not added any subjects yet.</p>
                                        </div>
                                    )}
                                </Fragment>
                            ) : activeBtn === "question-bank" ? (
                                !isViewed ?
                                    <Fragment>
                                        <div className="content-header">
                                            <div className='d-flex justify-content-between align-items-center' >
                                                <button onClick={() => addPrograms(null)}><img src="/images/plus-white.svg" alt="" /> &nbsp; Add Questions</button> &nbsp; &nbsp;
                                                <div className="has-search"  >
                                                    <span className="form-control-feedback">
                                                        <img src="/images/search1.svg" width="14" alt='' />
                                                    </span>
                                                    <input type='search' name='search' placeholder='' value={questionQuery} id='search' onChange={(e) => searchQuestionSubject(e.target.value)} autoComplete='off' className='form-control' />
                                                </div>
                                            </div>
                                            <div className="content-heading">
                                                <ul>
                                                    <li>
                                                        <div style={{ width: "20%", paddingLeft: 15 }}>
                                                            Subject
                                                        </div>
                                                        <div style={{ width: "20%", paddingLeft: 15 }}>
                                                            Questions
                                                        </div>
                                                        <div>MCQ</div>
                                                        <div>Subjective</div>
                                                        <div>
                                                            Actions
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        {
                                            isQuestionLoading ? (
                                                <div>
                                                    <TopicLoader />
                                                </div>
                                            ) :
                                                clubQuestionList !== undefined && clubQuestionList.length > 0 ? (

                                                    <ul className="program-list">
                                                        {
                                                            clubQuestionList.map((el, index) => {
                                                                return (
                                                                    <li key={el._id} style={{ cursor: 'default' }}>
                                                                        <div className="program-name" style={{ width: "20%" }}>
                                                                            <p>{el.name}</p>
                                                                        </div>
                                                                        <div style={{ width: "20%", textAlign: 'center' }}>
                                                                            <h3>{el.total_count}</h3>
                                                                        </div>
                                                                        <div
                                                                            className="program-name text-center"
                                                                            style={{ width: "20%" }}
                                                                        >
                                                                            <h3>{el.total_mcq}</h3>
                                                                        </div>
                                                                        <div
                                                                            className="program-name text-center"
                                                                            style={{ width: "20%" }}
                                                                        >
                                                                            <h3>{el.total_essay}</h3>
                                                                        </div>

                                                                        <div className="text-center cursor-pointer" onClick={() => el.total_count === 0 ? '' : viewQuestions(el)} style={{ color: el.total_count === 0 ? '#696873' : '#5855d6', pointerEvents: el.total_count === 0 ? 'none' : 'auto', fontWeight: 600 }}>
                                                                            View Questions
                                                                        </div>
                                                                    </li>
                                                                );
                                                            })}
                                                    </ul>
                                                ) : (
                                                    <div className="empty-list">
                                                        <img src="/images/empty.png" alt="" />
                                                        <p>You have not added any Questions yet.</p>
                                                    </div>
                                                )
                                        }
                                    </Fragment>
                                    : <Fragment>
                                        <div className="content-header">
                                            <div className='d-flex justify-content-between align-items-center' style={{ width: '90%' }}>
                                                <div className="d-flex align-items-center">
                                                    <button onClick={() => dispatch(resetLoader())} style={{ minWidth: 120 }}><img src="/images/back-white.svg" alt="" /> &nbsp; Back</button> &nbsp; &nbsp;
                                                    <button onClick={() => addPrograms(null)}><img src="/images/plus-white.svg" alt="" /> &nbsp; Add Questions</button> &nbsp; &nbsp;
                                                </div>
                                                <div className="has-search"  >
                                                    <span className="form-control-feedback">
                                                        <img src="/images/search1.svg" width="14" alt='' />
                                                    </span>
                                                    <input type='search' name='student' placeholder='' value={query} id='search' onChange={(e) => searchQuestions(e)} autoComplete='off' className='form-control' />
                                                </div>
                                                <div className='d-flex align-items-center cursor-pointer' style={{ marginLeft: '10%' }} onClick={openFilter}>
                                                    <img src='/images/filter-icon.svg' alt='' /> &nbsp;<p>Filters</p>
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-center mt-3" style={{ fontWeight: 600 }}>
                                                <p>Active Questions : {questionList?.filter(el => el.active)?.length}</p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                <p>Inactive Questions  : {questionList?.filter(el => !el.active)?.length}</p>
                                            </div>
                                            <div className="content-heading">
                                                <ul>
                                                    <li>
                                                        <div style={{ width: "10%", paddingLeft: 15 }}>
                                                            Type
                                                        </div>
                                                        <div style={{ width: "30%" }}>
                                                            Title
                                                        </div>
                                                        <div style={{ width: "20%" }}>
                                                            Chapter
                                                        </div>
                                                        <div style={{ width: "20%" }}>
                                                            Topic
                                                        </div>
                                                        {/* <div>Chapter</div> */}
                                                        {/* <div>Tags</div> */}
                                                        <div style={{ width: "10%" }}>Status</div>
                                                        <div style={{ width: "10%" }}>
                                                            Actions
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        {loading ? (
                                            <div>
                                                <TopicLoader />
                                            </div>
                                        ) :
                                            questionList !== undefined && questionList.length > 0 ? (

                                                <ul className="program-list">
                                                    {questionList !== undefined &&
                                                        questionList.map((el, index) => {
                                                            return (
                                                                <li key={index} style={{ cursor: 'default' }}>
                                                                    <div className="program-name" style={{ width: "10%" }}>
                                                                        <p>{el.type === 'mcq' ? 'MCQ' : "ESSAY"}</p>
                                                                    </div>
                                                                    <div style={{ width: "30%" }}>
                                                                        <p dangerouslySetInnerHTML={{ __html: el.description }} />
                                                                    </div>
                                                                    <div className="text-center" style={{ width: "20%" }}>
                                                                        <p>{el.chapter_name}</p>
                                                                    </div>
                                                                    <div className="text-center" style={{ width: "20%" }}>
                                                                        <p>{el.topic_name}</p>
                                                                    </div>
                                                                    {/* <div
                                                                        className="text-center"
                                                                        style={{ width: "20%" }}
                                                                    >
                                                                        <p>
                                                                            {el.chapter_name && el.chapter_name}
                                                                        </p>
                                                                    </div> */}
                                                                    {/* <div
                                                                        className="text-center"
                                                                        style={{ width: "20%" }}
                                                                    >
                                                                        <p>{el.tags && el.tags.map(e => e).join(', ')}</p>
                                                                    </div> */}
                                                                    <div className="text-center" style={{ width: "10%" }}>
                                                                        <p onClick={(e) => handleQuestionStatus(el._id, el.active)}>{" "}
                                                                            <Switch
                                                                                checked={el.active}
                                                                                width={30}
                                                                                height={16}
                                                                                uncheckedIcon={false}
                                                                                checkedIcon={false}
                                                                                onColor="#00B24B"
                                                                                onChange={(e) => { console.log(e) }}
                                                                            />
                                                                            <br />
                                                                            {el.active ? 'Active' : 'Inactive'}
                                                                        </p>
                                                                    </div>
                                                                    <div className="text-center cursor-pointer" style={{ width: "10%" }}>
                                                                        <img src="/images/edit.svg" alt="" onClick={() => addPrograms(el)} />{" "}
                                                                    </div>
                                                                </li>
                                                            );
                                                        })}
                                                </ul>
                                            ) : (
                                                <div className="empty-list">
                                                    <img src="/images/empty.png" alt="" />
                                                    <p>You have not added any Questions yet.</p>
                                                </div>
                                            )}
                                    </Fragment>

                            ) : activeBtn === "practice-test" ? (
                                <Fragment>
                                    <div className="content-header">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <button onClick={() => addPrograms(null)}>
                                                <img src="/images/plus-white.svg" alt="" /> &nbsp;Add
                                                Practice Test
                                            </button>
                                            <div className='d-flex align-items-center cursor-pointer' style={{ marginLeft: '10%' }} onClick={openQuestionFilter}>
                                                <img src='/images/filter-icon.svg' alt='' /> &nbsp;<p>Filters</p>
                                            </div>
                                            <div className="has-search"  >
                                                <span className="form-control-feedback">
                                                    <img src="/images/search1.svg" width="14" alt='' />
                                                </span>
                                                <input type='search' name='search' placeholder='' value={testQuery} id='search' onChange={(e) => searchPracticeTest(e.target.value)} autoComplete='off' className='form-control' />
                                            </div>
                                        </div>
                                        <div className="content-heading">
                                            <ul>
                                                <li>
                                                    <div style={{ width: '35%' }}>Title</div>
                                                    <div style={{ width: '30%' }}>Subjects</div>
                                                    <div>Questions</div>
                                                    <div>Duration(m)</div>
                                                    <div>Status</div>
                                                    <div>
                                                        Actions
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    {isClassLoading ? (
                                        <div>
                                            <TopicLoader />
                                        </div>
                                    ) :
                                        practiceList !== undefined && practiceList?.length > 0 ? (
                                            <ul className="program-list">
                                                {practiceList !== undefined &&
                                                    practiceList.map((el) => {
                                                        return (
                                                            <li key={el._id} style={{ cursor: 'default' }}>
                                                                <div className="program-name" style={{ width: '35%' }}>
                                                                    <p>{el.title}</p>
                                                                </div>

                                                                <div className="text-center" style={{ width: '30%' }}>
                                                                    <p>{el?.subjects?.map(el => el.name).join(', ')}</p>
                                                                </div>

                                                                <div className="text-center">
                                                                    <h3>{el.questions}</h3>
                                                                </div>
                                                                <div className="text-center">
                                                                    <h3>{el.time}</h3>
                                                                </div>
                                                                <div className="text-center">
                                                                    <p onClick={(e) => handleTestStatus(el._id, el.active)}
                                                                    >
                                                                        {" "}
                                                                        <Switch
                                                                            onChange={(e) => { console.log(e) }}
                                                                            checked={el.active}
                                                                            width={30}
                                                                            height={16}
                                                                            uncheckedIcon={false}
                                                                            checkedIcon={false}
                                                                            onColor="#00B24B"
                                                                        />
                                                                        <br />
                                                                        {el.active ? 'Active' : "Inactive"}
                                                                    </p>
                                                                </div>
                                                                <div className="text-center cursor-pointer">
                                                                    <img src="/images/edit.svg" alt="" onClick={() => addPrograms(el)} /> &nbsp;&nbsp;
                                                                    {/* <img src="/images/delete.svg" alt="" />
                            &nbsp;&nbsp;
                            <img src="/images/menu.svg" alt="" /> */}
                                                                </div>
                                                            </li>
                                                        );
                                                    })}
                                            </ul>
                                        ) : (
                                            <div className="empty-list">
                                                <img src="/images/empty.png" alt="" />
                                                <p>You have not added any Practice test yet.</p>
                                            </div>
                                        )}
                                </Fragment>
                            ) : activeBtn === "recorded-classes" ? (
                                <Fragment>
                                    <div className="content-header">
                                        {/* <Fragment>
                                            <div class="animated-search">
                                                <input
                                                    id="express-form-typeahead"
                                                    autoComplete="off"
                                                    onBlur={checkFocus}
                                                    onFocus={checkFocus}
                                                    spellCheck="false"
                                                    type="text"
                                                    value={search}
                                                    onChange={(e) => searchQuery(e.target.value)}
                                                />
                                                <div class="symbol">
                                                    <img src="/images/search1.svg" alt="" />
                                                </div>
                                                {isFocused ? (
                                                    <img
                                                        src="/images/close2.png"
                                                        alt=""
                                                        className="close-input"
                                                        onClick={() => setIsFocused(false)}
                                                    />
                                                ) : (
                                                    ""
                                                )}
                                            </div>
                                        </Fragment> */}
                                        
                                        <div className="content-heading">
                                            <ul>
                                                <li>
                                                    <div>Recorded Class</div>
                                                    <div>Type</div>
                                                    <div>Subject</div>
                                                    <div>Chapter</div>
                                                    <div>Sections</div>
                                                    <div style={{ width: '10%', textAlign: 'center' }}>Status</div>
                                                    <div style={{ width: '10%', textAlign: 'center' }}>Enable to Students</div>
                                                    <div style={{ width: '10%', textAlign: 'center' }}>Actions</div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    {isWhiteboardLoading ? (
                                        <div>
                                            <TopicLoader />
                                        </div>
                                    ) : (
                                        <ul className="program-list">
                                            {whiteboardList?.map((el, index) => (
                                                <li key={index}>
                                                    <div className='program-name text-capitalize d-flex align-items-center'>
                                                        <p>{el?.title}</p>
                                                    </div>
                                                    <div className='text-center'>{el?.type}</div>
                                                    <div className='text-center'>{el?.subject_id?.name}</div>
                                                    <div className='text-center'>{el?.chapter_id?.name}</div>
                                                    <div className='text-center' style={{
                                                        whiteSpace: 'nowrap',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        margin: '0 auto',
                                                        padding: '0 5px',
                                                        textAlign: 'center'
                                                        }} title={el?.section_ids?.map(section => section.name).join(', ')}>
                                                        {el?.section_ids?.length > 0 ? el.section_ids.map(section => section.name).join(', ') : 'N/A'}
                                                    </div>
                                                    <div className="text-center" style={{ width: '10%' }}>
                                                        <p
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                handleWhiteboardStatus(el);
                                                            }}
                                                        >
                                                            <Switch
                                                                width={30}
                                                                height={16}
                                                                uncheckedIcon={false}
                                                                checkedIcon={false}
                                                                onColor="#00B24B"
                                                                checked={el.active}
                                                                onChange={(e) => { console.log(e) }}
                                                            />
                                                            <br />
                                                            {el.active ? "Active" : "Inactive"}
                                                        </p>
                                                    </div>
                                                    <div className="text-center" style={{ width: '10%' }}>
                                                        <p
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                
                                                            }}
                                                        >
                                                            <Switch
                                                                width={30}
                                                                height={16}
                                                                uncheckedIcon={false}
                                                                checkedIcon={false}
                                                                onColor="#00B24B"
                                                                checked={el.enable}
                                                                onChange={(e) => { EnableWhiteBoardToStudents(el) }}
                                                            />
                                                            <br />
                                                            {el.enable ? "Enabled" : "Disabled"}
                                                        </p>
                                                    </div>
                                                    <div style={{ textAlign: 'center', width: '10%' }}>
                                                        <img src="images/view_grey.svg" alt="" onClick={() => {openView(el)}} />
                                                        {/* <img src="images/edit.svg" alt="" onClick={() => {editWhiteboard(el)}} /> */}
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </Fragment>
                            ) : null
                    }
                </div>
            ) : (
                <div>
                    <AddModal
                        type={activeBtn}
                        items={activeBtn === 'question-bank' ? editQuestionData : details}
                        edit={edit}
                        backToMain={backToMain}
                        savedClassroom={(obj) => dispatch(savedClassroom(obj))}
                        updateClassroom={(obj) => dispatch(updateClassroom(obj))}
                        resetPercentage={() => dispatch(resetPercentage())}
                        selectFromSubject={selectFromSubject}
                        savedQuestions={(obj) => dispatch(savedQuestions(obj))}
                        getChapterOfSub={(id) => dispatch(getChapterOfSub(id))}
                        questionListForQuiz={questionListForQuiz}
                        deleteAllQuestion={(obj) => dispatch(deleteQuizQuestions(obj))}
                        editedQuestion={async (obj) => {
                            await dispatch(editedQuestion(obj))
                            await dispatch(getSubjectFromClassroom(subject?.value))
                        }}
                        savedNewQuiz={(obj, type) => dispatch(savedNewQuiz(obj, type))}
                        editPracticeTest={(obj, type) => dispatch(editedQuiz(obj, type))}

                        subjectTopicList={props.subjectTopicList}
                        subjectChapters={subjectChapters}
                        getClubbedQuestionList={() => dispatch(getClubbedQuestionList())}
                        getQuizQuestion={(id) => dispatch(getQuizQuestion(id))}

                    />
                </div>
            )}

            <div className="resource-details" style={{ display: isView ? 'block' : 'none', }}>
                <ViewResource
                    activeFeedData={whiteboardDetails}
                    closeNotes={closeDetails}
                    isView={isView}
                />
            </div>

            {/* ################## Add subject modal ############################ */}
            <Modal
                show={isAddSubject}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                dialogClassName={"add-subject-modal"}
            >
                <AddSubjectModal
                    handleModal={handleModal}
                    savedSubject={(obj) => dispatch(savedSubject(obj))}
                    updateSubject={(obj) => dispatch(updateSubject(obj))}
                    items={editObj}
                    edit={editSubject}
                />
            </Modal>

            <Modal
                show={addSections}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                dialogClassName={"update-modal1"}
            >
                <Modal.Body style={{ padding: '22px 40px 22px 40px' }}>
                    <div>
                        <label>Select Sections</label>
                        <div className="mt-2">
                            <Select
                                noOptionsMessage={() => null}
                                value={selectedSections}
                                options={sectionsFromSubject && sectionsFromSubject.sections ? 
                                    [
                                        { value: 'all', label: 'All Sections' },
                                        ...sectionsFromSubject.sections.map(section => ({ 
                                        value: section._id, 
                                        label: section.name 
                                        }))
                                    ] : 
                                    []
                                }
                                isMulti
                                closeMenuOnSelect={false}
                                placeholder='Please type section name and enter'
                                onChange={(e) => handleSelectSections(e)}
                            />
                        </div>
                    </div>
                    <div className='save-btn'>
                        <button onClick={() => handleAddSections()}>Add Sections</button>
                        <button onClick={() => setAddSections(false)}>Cancel</button>
                    </div>
                </Modal.Body>
            </Modal>

            {/* ################## subject filter modal ############################ */}
            <Modal
                show={isOpenFilter}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                dialogClassName={"update-modal1"}
            >
                <Modal.Body style={{ padding: '22px 40px 22px 40px' }}>
                    {/* <div>
                        <label>Subject</label>
                        <div className="mt-2">
                            <Select
                                components={{ DropdownIndicator }}
                                options={selectFromSubject}
                                onChange={selectSubject}
                                placeholder='Select Subject'
                                value={subject}
                            />
                        </div>
                    </div> */}
                    <div>
                        <label>Chapter</label>
                        <div className="mt-2">
                            <Select
                                components={{ DropdownIndicator }}
                                options={chapterList.map(item => ({ ...item, label: item.name, value: item._id }))}
                                onChange={handleChapterChange}
                                placeholder='Select Chapter'
                                value={chapter}
                            />
                        </div>
                    </div>
                    <div>
                        <label>Topic</label>
                        <div className="mt-2">
                            <Select
                                components={{ DropdownIndicator }}
                                options={topicsList?.map(item => ({ ...item, label: item.name, value: item._id }))}
                                onChange={handleTopicChange}
                                placeholder='Select Topic'
                                value={topic}
                                isDisabled={!chapter}
                            />
                        </div>
                    </div>
                    <div className='save-btn'>
                        <button onClick={() => applyFilter()}>Apply</button>
                        <button onClick={() => setIsOpenFilter(false)}>Cancel</button>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal
                show={isOpenQuestionFilter}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                dialogClassName={"update-modal1"}
            >
                <Modal.Body style={{ padding: '22px 40px 22px 40px' }}>
                    <div>
                        <label>Subject</label>
                        <div className="mt-2">
                            <Select
                                components={{ DropdownIndicator }}
                                options={selectFromSubject}
                                onChange={selectSubject}
                                placeholder='Select Subject'
                                value={subject}
                            />
                        </div>
                    </div>
                    <div className='save-btn'>
                        <button onClick={() => applyQuestionFilter()}>Apply</button>
                        <button onClick={() => setIsOpenQuestionFilter(false)}>Cancel</button>
                    </div>
                </Modal.Body>
            </Modal>

            {/* ################## Confirm Delete modal ############################ */}
            <ConfirmModal
                isConfirm={isConfirm}
                confirmDelete={async () => {
                    activeBtn === 'subject' ? await dispatch(confirmDelete(deleteId)) : await dispatch(confirmDeleteClassroom(deleteId))
                    await setIsConfirm(false)
                }}
                closeModal={() => setIsConfirm(false)}
                type={activeBtn}
            />
        </Fragment>
    );
}


export default ManageContent